import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import brand, { getDrawByKey } from "../brand";
import ResultImagePanel from "../components/ResultImagePanel";
import { downloadResultPdf, fetchResultImage, getTodayIsoDate, shareResult } from "../utils/resultApi";

const DrawResultPage = ({ time }) => {
  const draw = getDrawByKey(time);
  const [imageUrl, setImageUrl] = useState(null);
  const [message, setMessage] = useState(`${draw.label} result is coming shortly`);
  const [loading, setLoading] = useState(true);
  const [notice, setNotice] = useState("");

  useEffect(() => {
    let active = true;

    const loadResult = async () => {
      try {
        const image = await fetchResultImage(draw.key);
        if (!active) return;
        setImageUrl(image);
        setMessage(image ? "" : `${draw.label} result is coming shortly`);
      } catch (error) {
        if (!active) return;
        setMessage("Unable to load the result right now.");
        setImageUrl(null);
      } finally {
        if (active) setLoading(false);
      }
    };

    loadResult();
    const interval = window.setInterval(loadResult, 60000);
    return () => {
      active = false;
      window.clearInterval(interval);
    };
  }, [draw.key]);

  const handleDownload = async () => {
    try {
      await downloadResultPdf(imageUrl, draw.key);
    } catch (error) {
      setNotice(error.message);
    }
  };

  const handleShare = async () => {
    try {
      const result = await shareResult({
        title: `${brand.name} ${draw.label} Result`,
        text: `${brand.name} ${draw.label} result for ${getTodayIsoDate()}`,
      });
      setNotice(result === "copied" ? "Result link copied." : "Share panel opened.");
    } catch (error) {
      setNotice("Sharing is not available on this device.");
    }
  };

  return (
    <main className="page-shell">
      <section className="page-hero compact-hero">
        <span className="eyebrow">{draw.name}</span>
        <h1>
          {brand.name} {draw.label} Result
        </h1>
        <p>
          Auto-updated result image, animated draw preview, PDF download, and
          one-tap sharing for today's Shillong draw.
        </p>
        <div className="hero-links">
          {brand.drawTimes.map((item) => (
            <Link
              key={item.key}
              to={item.key === "1pm" ? "/onepmresult" : "/eightpmresult"}
              className={item.key === draw.key ? "active" : ""}
            >
              {item.label}
            </Link>
          ))}
          <Link to="/oldresult">History</Link>
        </div>
      </section>

      {notice && <div className="toast-line">{notice}</div>}

      <ResultImagePanel
        title={brand.name}
        draw={draw}
        imageUrl={imageUrl}
        loading={loading}
        message={message}
        onDownload={handleDownload}
        onShare={handleShare}
        featured
      />
    </main>
  );
};

export default DrawResultPage;
